import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import fr from "./locales/fr/translation.json";
import de from "./locales/de/translation.json";
import it from "./locales/it/translation.json";
import ar from "./locales/ar/translation.json";

const supportedLanguages = ["en", "fr", "de", "it", "ar"] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      de: { translation: de },
      it: { translation: it },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    detection: {
      order: ["querystring", "navigator"],
      lookupQuerystring: "lang",
      caches: [],
    },
    interpolation: {
      escapeValue: false,
      format(value, format, lng) {
        if (
          format === "number" &&
          typeof value === "number" &&
          typeof Intl !== "undefined"
        ) {
          return new Intl.NumberFormat(lng).format(value);
        }
        return value as string;
      },
    },
  });

export default i18n;
